module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_j_albino.0bae041e.png";